'use client';

import { c as _c } from "react/compiler-runtime";
import 'keen-slider/keen-slider.min.css';
import { type KeenSliderInstance, useKeenSlider } from 'keen-slider/react';
import { motion } from 'motion/react';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { cn } from '@src/utils/tailwind';
export interface QuoteReviewsProps {
  className?: string;
  backgroundColor?: string;
  mainQuoteColor?: string;
  secondaryQuoteColor?: string;
  alignment?: 'center' | 'auto';
  reviews: Array<{
    mainQuote: string;
    secondaryQuote?: string;
    imageQuoteUrl?: string;
    imageQuoteAlt?: string;
    thumbnailUrl?: string;
    thumbnailAlt?: string;
  }>;
}
export function QuoteReviews(props) {
  const $ = _c(30);
  const [slider, setSlider] = useState(null);
  const t0 = props.alignment ?? "center";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      loop: true,
      drag: true,
      mode: "free",
      renderMode: "performance",
      slides: {
        perView: "auto",
        origin: t0,
        spacing: 40
      }
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.alignment || $[3] !== props.reviews.length) {
    t2 = [function autoplayController(slider_0) {
      const animation = {
        duration: props.reviews.length * 5000,
        easing: _temp
      };
      let overflow = false;
      setSlider(slider_0);
      const setOverflow = function setOverflow() {
        overflow = slider_0.track.details.slidesLength > 1;
        slider_0.update({
          ...slider_0.options,
          loop: overflow,
          drag: overflow,
          slides: {
            ...(slider_0.options.slides as any),
            origin: overflow ? props.alignment ?? "center" : "auto"
          }
        });
        if (!overflow) {
          const center = (1 - slider_0.track.details.slidesLength) / -2;
          slider_0.track.to(center);
        }
      };
      slider_0.on("created", () => {
        setOverflow();
        if (!overflow) {
          return;
        }
        slider_0.moveToIdx(props.reviews.length - 1, true, animation);
      });
      slider_0.on("updated", () => {
        setOverflow();
        if (!overflow) {
          return;
        }
        slider_0.moveToIdx(slider_0.track.details.abs + props.reviews.length - 1, true, animation);
      });
      slider_0.on("animationEnded", () => {
        if (!overflow) {
          return;
        }
        slider_0.moveToIdx(slider_0.track.details.abs + props.reviews.length - 1, true, animation);
      });
    }];
    $[2] = props.alignment;
    $[3] = props.reviews.length;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [ref] = useKeenSlider(t1, t2);
  let t3;
  if ($[5] !== slider) {
    t3 = () => {
      if (slider) {
        slider.update(slider.options);
        slider.emit("updated");
      }
    };
    $[5] = slider;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props.reviews.length || $[8] !== slider) {
    t4 = [slider, props.reviews.length];
    $[7] = props.reviews.length;
    $[8] = slider;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = slider ? 1 : 0;
  let t7;
  if ($[11] !== t6) {
    t7 = {
      opacity: t6
    };
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = !slider;
  let t9;
  if ($[13] !== props.className || $[14] !== t8) {
    t9 = cn("keen-slider flex items-start", props.className, {
      "gap-10": t8
    });
    $[13] = props.className;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== props.backgroundColor || $[17] !== props.mainQuoteColor || $[18] !== props.reviews || $[19] !== props.secondaryQuoteColor) {
    let t11;
    if ($[21] !== props.backgroundColor || $[22] !== props.mainQuoteColor || $[23] !== props.secondaryQuoteColor) {
      t11 = (review, index) => <QuoteReview key={index} className="keen-slider__slide" backgroundColor={props.backgroundColor} mainQuote={review.mainQuote} mainQuoteColor={props.mainQuoteColor} secondaryQuote={review.secondaryQuote} secondaryQuoteColor={props.secondaryQuoteColor} imageQuoteUrl={review.imageQuoteUrl} imageQuoteAlt={review.imageQuoteAlt} thumbnailUrl={review.thumbnailUrl} thumbnailAlt={review.thumbnailAlt} />;
      $[21] = props.backgroundColor;
      $[22] = props.mainQuoteColor;
      $[23] = props.secondaryQuoteColor;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    t10 = props.reviews.map(t11);
    $[16] = props.backgroundColor;
    $[17] = props.mainQuoteColor;
    $[18] = props.reviews;
    $[19] = props.secondaryQuoteColor;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[25] !== ref || $[26] !== t10 || $[27] !== t7 || $[28] !== t9) {
    t11 = <motion.div ref={ref} initial={t5} animate={t7} className={t9} data-keen-slider-disabled={true}>{t10}</motion.div>;
    $[25] = ref;
    $[26] = t10;
    $[27] = t7;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
function _temp(t) {
  return t;
}
interface QuoteReviewProps {
  className?: string;
  mainQuote: string;
  mainQuoteColor?: string;
  secondaryQuote?: string;
  secondaryQuoteColor?: string;
  imageQuoteUrl?: string;
  imageQuoteAlt?: string;
  thumbnailUrl?: string;
  thumbnailAlt?: string;
  backgroundColor?: string;
}
function QuoteReview(props) {
  const $ = _c(27);
  let t0;
  if ($[0] !== props.className) {
    t0 = cn(props.className, "flex min-h-[152px]! min-w-[calc(100%-2rem)] gap-4 rounded-xl p-4 lg:max-w-[443px] lg:min-w-[443px]");
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.backgroundColor) {
    t1 = {
      backgroundColor: props.backgroundColor
    };
    $[2] = props.backgroundColor;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.thumbnailAlt || $[5] !== props.thumbnailUrl) {
    t2 = props.thumbnailUrl && <Image className="size-[120px] rounded-xl" width={120} height={120} src={props.thumbnailUrl} alt={props.thumbnailAlt ?? ""} />;
    $[4] = props.thumbnailAlt;
    $[5] = props.thumbnailUrl;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.imageQuoteAlt || $[8] !== props.imageQuoteUrl) {
    t3 = props.imageQuoteUrl && <Image className="w-[80px] object-contain object-left" width={80} height={80} src={props.imageQuoteUrl} alt={props.imageQuoteAlt ?? ""} />;
    $[7] = props.imageQuoteAlt;
    $[8] = props.imageQuoteUrl;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props.mainQuoteColor) {
    t4 = {
      color: props.mainQuoteColor
    };
    $[10] = props.mainQuoteColor;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props.mainQuote || $[13] !== t4) {
    t5 = <div className="text-heading-4" style={t4}>{props.mainQuote}</div>;
    $[12] = props.mainQuote;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== props.secondaryQuote || $[16] !== props.secondaryQuoteColor) {
    t6 = props.secondaryQuote && <div className="text-body-md" style={{
      color: props.secondaryQuoteColor
    }}>{props.secondaryQuote}</div>;
    $[15] = props.secondaryQuote;
    $[16] = props.secondaryQuoteColor;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className="flex flex-1 flex-col justify-center gap-1">{t3}{t5}{t6}</div>;
    $[18] = t3;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t0 || $[23] !== t1 || $[24] !== t2 || $[25] !== t7) {
    t8 = <div className={t0} style={t1}>{t2}{t7}</div>;
    $[22] = t0;
    $[23] = t1;
    $[24] = t2;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}